"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = require("react");

var _shallowequal = _interopRequireDefault(require("shallowequal"));

require("intersection-observer");

const _excluded = ["defaultIntersecting", "once"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const intersectionOptions = {
  root: undefined,
  rootMargin: '0px',
  threshold: 0.15,
  once: true,
  defaultIntersecting: false
};

var _default = function _default(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : intersectionOptions;
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

  const {
    defaultIntersecting,
    once
  } = options,
        opts = _objectWithoutProperties(options, _excluded);

  const optsRef = (0, _react.useRef)(opts);
  const [intersecting, setIntersecting] = (0, _react.useState)(defaultIntersecting === true);
  const intersectedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (!(0, _shallowequal.default)(optsRef.current, opts)) {
      optsRef.current = opts;
    }
  });
  (0, _react.useEffect)(() => {
    if (target == null) {
      return;
    }

    const element = target instanceof Element ? target : target.current;

    if (element == null) {
      return;
    }

    const observer = new IntersectionObserver(entries => {
      const entry = entries[entries.length - 1];
      setIntersecting(entry.isIntersecting);

      if (callback != null) {
        callback(entry);
      }

      if (entry.isIntersecting) {
        intersectedRef.current = true;
      }

      if (once && entry.isIntersecting && element != null) {
        observer.unobserve(element);
      }
    }, _objectSpread(_objectSpread({}, optsRef.current), {}, {
      root: optsRef.current.root != null ? optsRef.current.root.current : null
    }));
    observer.observe(element);

    if (once && intersectedRef.current) {
      observer.unobserve(element);
      return;
    }

    return () => {
      if (once && intersectedRef.current) {
        return;
      }

      if (element != null) {
        observer.unobserve(element);
      }
    };
  }, [optsRef.current, target]);
  return intersecting;
};

exports.default = _default;